import Text from 'common-components/Text'

import * as Styled from './styled'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { useResponsive } from 'hooks/useResponsive'
import SpidernetIcon from 'assets/svgr-icons/Spidernet_Icon.svg'
import { translate } from 'utils/translations'
import DragDropUpload from 'components/DragDropUpload'
import { DragAreaActiveContent } from 'containers/SubSidebar/AudioContent/components/drag-area-active-content'
import { T } from 'consts/translationKeys'
import { useAudioUpload } from 'hooks/project-item-upload'

const CommonComponent: React.FC = () => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  return (
    <Styled.NoMusicDndAreaWrapper>
      <Styled.SpiderIconWrapper>
        <SpidernetIcon />
      </Styled.SpiderIconWrapper>

      <Text type="h2" color="secondarySemiDark">
        {translate(T.OOPS_NOTHING_HERE)}
      </Text>

      {!isMobile && (
        <Styled.NoMusicDndAreaText
          color="secondarySemiDark"
          type="h4"
          lineHeight="14.63px"
        >
          {translate(T.DRAG_AND_DROP_A_FILE_OR_USE_UPLOAD_BUTTON)}
        </Styled.NoMusicDndAreaText>
      )}
    </Styled.NoMusicDndAreaWrapper>
  )
}

const NoMusicViewMobile: React.FC = () => {
  return <CommonComponent />
}

const NoMusicViewDesktop: React.FC = () => {
  return (
    <>
      <CommonComponent />

      <DragAreaActiveContent />
    </>
  )
}

export const NoMusicView: React.FC = () => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  const handleFilesUpload = useAudioUpload()

  if (isMobile) {
    return <NoMusicViewMobile />
  }

  return (
    <DragDropUpload acceptType={'audio'} filesHandler={handleFilesUpload}>
      <NoMusicViewDesktop />
    </DragDropUpload>
  )
}
